<template>
  <div class="visit-registering">
    <section class="pre-reg-head-tab1">
      <div class="visit-register-header">
        <div class="logo">
          <img src="@/assets/images/logo-lg.svg" alt="-visipoint-logo" />
        </div>
      </div>
      <h3 class="welcome-msg">{{ $t('common.welcome') }}</h3>
      <div>
        <p class="reg-msg-tab1">{{ $t('common.registerVisit')}}</p>
      </div>
    </section>

    <p class="selected-name">{{ $t('preRegisteration.select_host')}}</p>

    <div class="select-user d-flex" style="position: relative">
      <svg
        data-v-360da7f5=""
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="position: absolute; margin: 20px 30px; z-index: 99"
      >
        <path
          data-v-360da7f5=""
          d="M13.7467 15C14.0674 15 14.3884 14.8777 14.6329 14.6328C15.1224 14.1435 15.1224 13.3498 14.6329 12.8603L11.586 9.8135C13.2154 7.3595 12.9497 4.00983 10.7883 1.8485C8.32362 -0.616167 4.31323 -0.616167 1.84853 1.8485C-0.616175 4.31317 -0.616175 8.3235 1.84853 10.7883C3.08088 12.0207 4.69973 12.6368 6.31842 12.6368C7.53877 12.6368 8.75879 12.2863 9.81364 11.586L12.8605 14.6328C13.105 14.8777 13.4259 15 13.7467 15ZM3.40305 9.23367C1.79569 7.62633 1.79569 5.01083 3.40305 3.4035C4.20673 2.59983 5.26257 2.19783 6.31825 2.19783C7.37394 2.19783 8.42978 2.59967 9.23363 3.4035C10.841 5.01083 10.841 7.62633 9.23363 9.23367C7.62611 10.841 5.01057 10.841 3.40305 9.23367Z"
          fill="#787878"
        ></path>
      </svg>
      <multiselect
        id="searching-by"
        :placeholder="$t('preRegisteration.searchByName')"
        :options="hostOptions"
        :searchable="true"
        @search-change="searchByUserName"
        v-model="user"
        label="DisplayName"
        track-by="user_id"
        :internal-search="false"
        @input="hostChanged()"
      >
        <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
        <span slot="noOptions">{{$t('common.emptList')}}</span>
      </multiselect>
      <!-- <div class="spinner-border" role="status" v-if="userLoading"></div> -->
    </div>

    <div>
      <p class="note-msg" v-if="getNameSearchType == 'PRIVATE'">
        <strong class="strong-note-msg"> {{ $t('common.notes.note') }}:</strong>{{  $t('preRegisteration.search_hint') }} }}
      </p>
    </div>

    <div
      class="col-lg-12"
      :class="{
        'no-notes-container': getNameSearchType == 'QUICK',
        'host-check': getNameSearchType == 'PRIVATE',
      }"
      v-if="getAllowNotSelectHost"
    >
      <b-form-checkbox-group v-model="hostSelected" size="lg">
        <b-form-checkbox class="custom-checkbox-secondary custom-checkbox">
          <p class="text">{{ $t('preRegisteration.unknown_host')}}</p>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </div>

    <div class="confirm-btn">
      <button
        class="btn btn-primary"
        @click="nextClicked()"
        :class="{
          'no-content-btn':
            !getAllowNotSelectHost && getNameSearchType == 'QUICK',
          'checkbox-only-btn':
            getAllowNotSelectHost && getNameSearchType == 'QUICK',
          'note-only-btn':
            !getAllowNotSelectHost && getNameSearchType == 'PRIVATE',
          'all-content-btn':
            getAllowNotSelectHost && getNameSearchType == 'PRIVATE',
        }"
        :disabled="(!hostSelected && !user) || isLoading"
      >
        <i
          v-if="isLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ $t('common.next').toUpperCase() }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      hostOptions: [],
      user: "",
      notAllowToReg: false,
      hostSelected: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("userType", [
      "getNameSearchType",
      "getAllowNotSelectHost",
      "getJourneyId",
      "getTouchModeStatus",
    ]),
    ...mapGetters("preRegistration", [
      "getRegisterPassportAcc",
      "getSelectedUserType",
      "getEmail",
      "getPhone",
      "getCompliance",
      "getUserEntity",
      "getUser",
    ]),
  },
  methods: {
    ...mapActions("userType", ["fetchAllHosts"]),
    ...mapActions("preRegistration", ["setSelectedHost"]),
    searchByUserName(value) {
      // console.log(
      //   "searchByUserName",
      //   this.getRegisterPassportAcc,
      //   JSON.parse(this.$route.query.getUserEntities)
      // );
      this.hostOptions = [];
      let obj = {
        journey_id: this.getJourneyId,
        name: value,
        search_mode: this.getNameSearchType,
        url: this.$route.params.id,
        user_type_id: this.getSelectedUserType[0].id,
      };
      if (this.$route.query && this.$route.query.comingFromPassport) {
        if (JSON.parse(this.$route.query.getUserEntities))
          obj.passport_id = this.$route.query.passport_id;
        else {
          if (this.$route.query.email)
            obj.email = this.$route.query.email
              ? decodeURIComponent(this.$route.query.email)
              : null;
          if (!this.$route.query.email && this.$route.query.phone)
            obj.phone = this.$route.query.phone
              ? decodeURIComponent(this.$route.query.phone)
              : null;
        }
      } else {
        if (this.getEmail) obj.email = this.getEmail ? this.getEmail : null;
        if (!this.getEmail && this.getPhone)
          obj.phone = this.getPhone ? this.getPhone : null;
      }
      if (this.getNameSearchType == "QUICK" && value.length >= 3) {
        // console.log("quick name match");
        this.fetchAllHosts(obj).then((data) => {
          // console.log("res", data);
          this.hostOptions = data.data.data;
        });
      } else if (
        this.getNameSearchType == "PRIVATE" &&
        value.includes(" ") &&
        value.split(" ")[1] &&
        value.split(" ")[1].trim().length >= 2
      ) {
        // console.log("Private name match");
        this.fetchAllHosts(obj).then((data) => {
          // console.log("res", data);
          this.hostOptions = data.data.data;
        });
      }
    },

    hostChanged() {
      // console.log("hstch", this.user);
      this.hostSelected = false;
      this.setSelectedHost(this.user ? this.user.user_id : "");
    },

    nextClicked() {
      // console.log("nexxt", this.user, this.hostSelected);
      this.isLoading = true;
      if (this.getCompliance.is_image_required && !this.getUserEntity?.image) {
        setTimeout(() => {
          this.$emit("next");
        }, 500);
      } else {
        this.$emit("finish");
      }
      // this.isLoading = false;
    },
  },
  watch: {
    getApiErr(value) {
      if (value) this.isLoading = false;
    },
    hostSelected(val) {
      if (val) {
        this.user = null;
        this.setSelectedHost("");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.visit-registering {
  padding: 46px 38px 40px 38px;
  margin-top: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 491px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  .reg-msg-tab1 {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    margin-bottom: 36px;
    color: rgba(0, 0, 0, 0.28);
  }
  .pre-reg-head-tab1 {
    .visit-register-header {
      .logo {
        width: 86px;
        height: 16px;
        margin: 0px auto 21px;
      }
    }
    .welcome-msg {
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 9px;

      text-align: center;

      color: #000000;
    }
  }
  .selected-name {
    text-align: start;
    margin-bottom: 31px;
    margin-inline-start: 17px;

    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
  }
  .note-msg {
    margin-top: 8px;
    margin-inline-start: 17px;
    text-align: start;

    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    /* text-align: center; */
    letter-spacing: 0.25px;
    color: #939393;
    opacity: 0.8;
    margin-bottom: 0px;
    .strong-note-msg {
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      /* text-align: center; */
      letter-spacing: 0.25px;
      color: #939393;
      opacity: 0.8;
    }
  }
  .host-check {
    margin-top: 33px;
    p.text {
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.25px;
      color: #666666;
    }
  }
  .no-notes-container {
    margin-top: 40px;
  }

  //////////////////
  .confirm-btn {
    .no-content-btn {
      margin-top: 66px;
    }
    .checkbox-only-btn {
      margin-top: 66px;
    }
    .note-only-btn {
      margin-top: 66px;
    }
    .all-content-btn {
      margin-top: 133px;
    }
    .no-content-btn,
    .checkbox-only-btn,
    .note-only-btn,
    .all-content-btn {
      width: 415px;
      height: 44px;
      border-radius: 26px;
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      text-align: center;
      letter-spacing: 0.25px;
      color: rgba(255, 255, 255, 0.87);
    }
  }
}
@media (max-width: 992px) {
  .visit-registering {
    padding: 86px 25px 40px 25px;
    margin-top: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 360px;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 0px;
    .reg-msg-tab1 {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height, or 143% */

      text-align: center;
      letter-spacing: 0.25px;
      margin-bottom: 51px;

      color: #666666;
    }
    .pre-reg-head-tab1 {
      .visit-register-header {
        .logo {
          width: 116px;
          height: 22px;
          margin: 0px auto 36px auto;
        }
      }
      .welcome-msg {
        font-weight: 500;
        font-size: 17px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #000000;
        mix-blend-mode: normal;
        margin-bottom: 21px;
      }
    }
    .selected-name {
      text-align: start;
      margin-inline-end: 40px;
      margin-bottom: 31px;
      margin-inline-start: 17px;

      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: #787878;
    }
    .note-msg {
      margin-top: 8px;
      margin-inline-start: 17px;
      text-align: start;

      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      letter-spacing: 0.25px;
      color: #939393;
      opacity: 0.8;
      margin-bottom: 0px;
      .strong-note-msg {
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.25px;
        color: #939393;
        opacity: 0.8;
      }
    }
    .host-check {
      margin-top: 33px;
      p.text {
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #666666;
      }
    }
    .no-notes-container {
      margin-top: 33px;
    }
    .no-content-btn {
      width: 415px;
      height: 44px;
      border-radius: 26px;

      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      text-align: center;
      letter-spacing: 0.25px;

      color: rgba(255, 255, 255, 0.87);
    }
    .confirm-btn {
      .no-content-btn {
        margin-top: 360px;
      }
      .checkbox-only-btn {
        margin-top: 310px;
      }
      .note-only-btn {
        margin-top: 291px;
      }
      .all-content-btn {
        margin-top: 240px;
      }
      .no-content-btn,
      .checkbox-only-btn,
      .note-only-btn,
      .all-content-btn {
        width: 309px;
        height: 37px;
        border-radius: 18.5px;
        font-weight: 500;
        font-size: 16px;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0.25px;
        text-transform: uppercase;

        color: #ffffff;
      }
    }
  }
}
</style>
<style lang="scss">
.custom-checkbox-secondary
  .custom-control-input:checked
  ~ .custom-control-label:before {
  background: #000000;
  border-color: #000000;
}
.visit-registering {
  .multiselect {
    width: 422px !important;

    border-radius: 4px !important;
    .multiselect__select {
      top: 7px !important;
    }
    .multiselect__tags {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px !important;
      border: none !important;
      display: flex;
      align-items: center;
      .multiselect__single {
        background: #f2f2f2 !important;

        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        width: 300px !important;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.87);
        opacity: 0.8;
      }
      .multiselect__placeholder {
        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        margin-inline-start: 57px;
        letter-spacing: 0.25px;
        color: #606060 !important;
      }
    }
  }
  input#searching-by {
    background: #f2f2f2 !important;

    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    padding-inline-start: 57px !important;
    border-radius: 4px !important;
    .multiselect__select {
      top: 7px !important;
    }
    .multiselect__tags {
      height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px !important;
      border: none !important;
      display: flex;
      align-items: center;
      .multiselect__single {
        background: #f2f2f2 !important;

        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        width: 300px !important;
        letter-spacing: 0.25px;
        color: rgba(0, 0, 0, 0.87);
        opacity: 0.8;
      }
      .multiselect__placeholder {
        font-weight: 400;
        font-size: 16px;
        line-height: 17px;
        margin-inline-start: 57px;
        letter-spacing: 0.25px;
        color: #606060 !important;
      }
    }
  }
  input#searching-by {
    background: #f2f2f2 !important;

    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    padding-inline-start: 57px !important;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.8;
    &::placeholder {
      font-weight: 400;
      font-size: 16px;
      line-height: 17px;
      letter-spacing: 0.25px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0.8;
    }
  }

  span.multiselect__single {
    font-weight: 900 !important;
    font-size: 16px;
    line-height: 17px;
    margin-inline-start: 57px !important;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.8;
  }
}
@media (max-width: 992px) {
  .visit-registering {
    .multiselect {
      width: 306px !important;
      border-radius: 4px !important;
    }
  }
}
</style>
